export default "__VITE_ASSET__Bc8qm5kS__"